export default __webpack_public_path__ + "static/media/MPSmallQR.08273a89.png";